module.exports = __webpack_public_path__ + "img/Recurso 40@300x l.27989de9.png";